import { Button } from "@/components/kit";

type ReportShowMoreProps = {
  visible: boolean;
  onShowMore: () => void;
  loading?: boolean;
  className?: string;
};

export function ReportShowMore({
  visible,
  onShowMore,
  loading,
  className,
}: ReportShowMoreProps) {
  if (!visible) return null;

  return (
    <div className={className ?? "flex justify-center py-3"}>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="rounded-full"
        disabled={loading}
        onClick={onShowMore}
      >
        {loading ? "ກຳລັງໂຫຼດ..." : "ເບິ່ງເພີ່ມ"}
      </Button>
    </div>
  );
}
